import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    getProjects(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.projects : [];
    },
    canRetrieveProjects(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.canLoadMore : true;
    },
    getRetrieveProjectsIndex(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.index : 0;
    },
    isRetrieveProjectsRequestFailure(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectsRequestPending(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectsRequestSuccess(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
